import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { conformToMask, adjustCaretPosition } from 'text-mask-core';
import setCaretPosition from './utils/setCaretPosition.js';
import DSTextBox from '../TextBox/DSTextBox.js';
import 'react-desc';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getValueFromEventOrString = function getValueFromEventOrString(e) {
  var value = e;

  if (e && e.target) {
    var eValue = e.target.value;
    value = eValue;
  }

  return value;
};

var getRawMask = function getRawMask(mask) {
  var rawValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return typeof mask === 'function' ? mask(rawValue) : mask;
}; // this is not safe because we don't take in consideration a lot of cases
// just a monkeypatch untill we get the v2 going,
// this work with "internal" masks...


var UNSAFEGetRawValue = function UNSAFEGetRawValue(value, mask) {
  var _safeValue$split, _safeValue$split$filt;

  var safeValue = getValueFromEventOrString(value);
  if (!safeValue) return '';
  var rawMask = getRawMask(mask, value);
  var characterToStrip = rawMask.filter(function (char) {
    return typeof char === 'string';
  });
  return safeValue === null || safeValue === void 0 ? void 0 : (_safeValue$split = safeValue.split('')) === null || _safeValue$split === void 0 ? void 0 : (_safeValue$split$filt = _safeValue$split.filter(function (char) {
    var indexCharToStrip = characterToStrip.findIndex(function (strip) {
      return strip === char;
    });

    if (indexCharToStrip >= 0) {
      characterToStrip.splice(indexCharToStrip, 1);
      return false;
    }

    return true;
  })) === null || _safeValue$split$filt === void 0 ? void 0 : _safeValue$split$filt.join('');
}; // this is not safe because we don't take in consideration a lot of cases
// just a monkeypatch untill we get the v2 going,
// this work with "internal" masks...


var UNSAFEIsRawValue = function UNSAFEIsRawValue(value, mask) {
  var _safeValue$split2;

  var safeValue = getValueFromEventOrString(value);
  if (!safeValue) return false;
  var rawMask = getRawMask(mask, safeValue);
  var characterToStrip = rawMask.filter(function (char) {
    return typeof char === 'string';
  });
  if (safeValue) safeValue === null || safeValue === void 0 ? void 0 : (_safeValue$split2 = safeValue.split('')) === null || _safeValue$split2 === void 0 ? void 0 : _safeValue$split2.forEach(function (char) {
    var indexCharToStrip = characterToStrip.findIndex(function (strip) {
      return strip === char;
    });

    if (indexCharToStrip >= 0) {
      characterToStrip.splice(indexCharToStrip, 1);
    }
  }); // if we matched all the character to strip, this is not a raw value
  // unsafe, but "good enough" for most masks...

  return characterToStrip.length !== 0;
};

var DSInputMaskDeprecated = /*#__PURE__*/function (_Component) {
  _inherits(DSInputMaskDeprecated, _Component);

  var _super = _createSuper(DSInputMaskDeprecated);

  function DSInputMaskDeprecated(props) {
    var _this;

    _classCallCheck(this, DSInputMaskDeprecated);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "lastkey", null);

    _defineProperty(_assertThisInitialized(_this), "lastkeycode", null);

    _defineProperty(_assertThisInitialized(_this), "conformValue", function (rawValueOrEvent, currentCaretPosition) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$skipCaretPositio = _ref.skipCaretPositioning,
          skipCaretPositioning = _ref$skipCaretPositio === void 0 ? false : _ref$skipCaretPositio,
          _ref$skipOnChangeCall = _ref.skipOnChangeCallback,
          skipOnChangeCallback = _ref$skipOnChangeCall === void 0 ? false : _ref$skipOnChangeCall;

      var previousConformedValue = _this.state.previousConformedValue;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          mask = _this$props.mask,
          _this$props$placehold = _this$props.placeholderChar,
          placeholderChar = _this$props$placehold === void 0 ? '_' : _this$props$placehold,
          pipe = _this$props.pipe;
      var rawValue = getValueFromEventOrString(rawValueOrEvent); // short-circuit logic if user cleared the input

      if (rawValue.length === 0) {
        _this.setState({
          maskedValue: rawValue,
          previousConformedValue: rawValue,
          focus: true
        }, function () {
          var event = {
            target: {
              value: rawValue,
              originalValue: rawValue
            },
            lastkey: _this.lastkey
          };
          onChange(event);
        });

        return;
      }

      var rawMaskWithTraps = getRawMask(mask, rawValue);
      var rawMask = rawMaskWithTraps.filter(function (val) {
        return val !== '[]';
      }); // generate the final result we want to put in the state and in the input box

      var conformToMaskResults = conformToMask(rawValue, rawMask, _objectSpread({
        guide: false,
        placeholderChar: placeholderChar
      }, previousConformedValue && {
        previousConformedValue: previousConformedValue
      }));
      var pipelessConformed = conformToMaskResults.conformedValue; // when the last character must be always preserved we need to manually ensure it
      //  because
      //    conformToMask -> guide: false will interpeter the last character
      //     will remove the last character if it's part of the mask
      //   we may want to add a prop for this in the future?
      //   this is used for example with "decimal" and "percentage" masks

      var conformedValueEnsureLastMaskChar = pipelessConformed;
      var lastMaskChar = rawMask[rawMask.length - 1];
      var lastValueChar = pipelessConformed.charAt(pipelessConformed.length - 1);

      if (typeof lastMaskChar === 'string' && lastMaskChar !== lastValueChar) {
        conformedValueEnsureLastMaskChar = pipelessConformed + lastMaskChar;
      }

      var pipeResult = {
        indexesOfPipedChars: [],
        value: conformedValueEnsureLastMaskChar,
        valid: true
      };
      if (typeof pipe === 'function') pipeResult = pipe()(conformedValueEnsureLastMaskChar); // if the pipe results in an invalid value, we don't allow the change
      //   meaning the final result will be like the user never tried to change the input
      //   this is because the user will have to inject the validation in his pipe
      //   probably pipe is never used, because this never worked before...
      //   we will deprecate the "pipe" props in the future

      var conformedValue = pipeResult.valid ? pipeResult.value : previousConformedValue; // generate the "placeholder" used in calculating new caret position
      // this means we need
      //   empty string as a value
      //   guide:true
      //   we can ignore "previousConformedValue" parameter

      var generatedPlaceHolder = conformToMask('', rawMask, {
        guide: true,
        placeholderChar: placeholderChar
      });
      var _pipeResult = pipeResult,
          indexesOfPipedChars = _pipeResult.indexesOfPipedChars;
      var adjustCaretPositionOpts = {
        previousConformedValue: previousConformedValue,
        conformedValue: conformedValue,
        currentCaretPosition: currentCaretPosition,
        rawValue: rawValue,
        placeholderChar: placeholderChar,
        placeholder: generatedPlaceHolder.conformedValue,
        indexesOfPipedChars: indexesOfPipedChars,
        caretTrapIndexes: []
      };
      var caretPos = adjustCaretPosition(adjustCaretPositionOpts);

      _this.setState({
        maskedValue: conformedValue,
        previousConformedValue: conformedValue,
        focus: true
      }, function () {
        var event = {
          target: {
            value: conformedValue,
            originalValue: rawValue
          },
          lastkey: _this.lastkey
        };
        if (!skipOnChangeCallback) onChange(event);
        if (!skipCaretPositioning) setTimeout(function () {
          return setCaretPosition(_this.inputref, caretPos);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      var _e$target;

      var rawValue = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '';
      var selectionEnd = e.target.selectionEnd;
      var currentCaretPosition = selectionEnd;

      _this.conformValue(rawValue, currentCaretPosition);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      e.stopPropagation();
      var onKeyDown = _this.props.onKeyDown;
      _this.lastkey = e.key;
      _this.lastkeycode = e.keyCode;
      onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focus: false
      });

      onBlur(e);
    });

    _this.inputref = /*#__PURE__*/React.createRef();
    _this.state = {
      maskedValue: '',
      previousConformedValue: ''
    };
    _this.conformValue = _this.conformValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DSInputMaskDeprecated, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          mask = _this$props2.mask;
      var isAlreadyRaw = UNSAFEIsRawValue(value, mask);
      var rawVal = isAlreadyRaw ? value : UNSAFEGetRawValue(value, mask);
      if (rawVal === '') return; // if value from props is raw, we invoke onChange
      //  not invoking onChange on a raw value breaks the internal components depending on this...

      var shouldSkipOnChange = !isAlreadyRaw;
      this.conformValue(rawVal, rawVal.length, {
        skipCaretPositioning: true,
        skipOnChangeCallback: shouldSkipOnChange
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // ensure the mask is re-applied when value/mask props changes.
      // this is required by internal implementations like DSDateRangePicker
      var prevValOrEvent = prevProps.value,
          prevMask = prevProps.mask;
      var _this$props3 = this.props,
          valOrEvent = _this$props3.value,
          mask = _this$props3.mask;
      var value = getValueFromEventOrString(valOrEvent);
      var isAlreadyRaw = UNSAFEIsRawValue(value, mask);
      var rawVal = isAlreadyRaw ? value : UNSAFEGetRawValue(value, mask);
      if (rawVal === '') return;
      var rawMask = getRawMask(mask, rawVal);
      var prevVal = getValueFromEventOrString(prevValOrEvent);
      var prevIsAlreadyRaw = UNSAFEIsRawValue(prevVal, prevMask);
      var prevRawVal = prevIsAlreadyRaw ? prevVal : UNSAFEGetRawValue(prevVal, prevMask);
      var prevRawMask = getRawMask(prevMask, prevRawVal); // we need to compare "raw" masks, because mask sometimes are functions
      //  and if we don't compare raw mask, isEqual will produce unexpected result
      //  which would lead to infinite loops

      if (prevVal !== value || !isEqual(prevRawMask, rawMask)) {
        // if value from props is raw, we invoke onChange
        //  not invoking onChange on a raw value breaks the internal components depending on this...
        var shouldSkipOnChange = !isAlreadyRaw;
        this.conformValue(rawVal, rawVal.length, {
          skipCaretPositioning: true,
          skipOnChangeCallback: shouldSkipOnChange
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props;
          _this$props4.autoFocus;
          var style = _this$props4.style,
          disabled = _this$props4.disabled,
          className = _this$props4.className,
          name = _this$props4.name,
          maxLength = _this$props4.maxLength,
          minLength = _this$props4.minLength,
          fluidWidth = _this$props4.fluidWidth,
          placeholder = _this$props4.placeholder;
          _this$props4.onKeyDown;
          var onClick = _this$props4.onClick;
          _this$props4.onChange;
          var onFocus = _this$props4.onFocus;
          _this$props4.onBlur;
          var onPaste = _this$props4.onPaste,
          onKeyUp = _this$props4.onKeyUp,
          hasError = _this$props4.hasError,
          readOnly = _this$props4.readOnly,
          type = _this$props4.type,
          _innerRef = _this$props4.innerRef,
          _this$props4$clearabl = _this$props4.clearable,
          clearable = _this$props4$clearabl === void 0 ? false : _this$props4$clearabl,
          leftComponent = _this$props4.leftComponent,
          rightComponent = _this$props4.rightComponent,
          value = _this$props4.value,
          rest = _objectWithoutProperties(_this$props4, ["autoFocus", "style", "disabled", "className", "name", "maxLength", "minLength", "fluidWidth", "placeholder", "onKeyDown", "onClick", "onChange", "onFocus", "onBlur", "onPaste", "onKeyUp", "hasError", "readOnly", "type", "innerRef", "clearable", "leftComponent", "rightComponent", "value"]);

      var _this$state = this.state,
          maskedValue = _this$state.maskedValue,
          focus = _this$state.focus; // if component is "controlled" we print the value from the props
      // if it's not controlled we use the internal state
      // handleOnChange has the logic to invoke the onChange with the mask applied
      // if the dev controls the component but pass down a value not conformed to the mask
      // it's a problem to be fixed on the dev side.
      // this means no "get derived state from props" mumbo-jumbos

      var propsValue = getValueFromEventOrString(value);
      var finalValue = typeof propsValue === 'string' || typeof propsValue === 'number' ? propsValue : maskedValue;
      return /*#__PURE__*/React.createElement(DSTextBox, _extends({}, rest, {
        "aria-label": rest['aria-label'],
        className: className,
        clearable: clearable,
        disabled: disabled,
        fluidWidth: fluidWidth,
        hasError: hasError,
        innerRef: function innerRef(ref) {
          _this2.inputref = ref;
          if (_innerRef) _innerRef(ref);
        },
        isActive: focus,
        leftComponent: leftComponent,
        maxLength: maxLength,
        minLength: minLength,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleOnChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: onKeyUp,
        onPaste: onPaste,
        placeholder: placeholder,
        readOnly: readOnly,
        rightComponent: rightComponent,
        style: style,
        type: type,
        value: finalValue
      }));
    }
  }]);

  return DSInputMaskDeprecated;
}(Component);

DSInputMaskDeprecated.propTypes = {
  autoFocus: PropTypes.bool,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  fluidWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  leftComponent: PropTypes.element,
  rightComponent: PropTypes.element,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onPaste: PropTypes.func,
  onKeyUp: PropTypes.func,
  hasError: PropTypes.bool,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
  clearable: PropTypes.bool,
  type: PropTypes.string,

  /**
   * Ref for the component
   */
  innerRef: PropTypes.any,

  /**
   * Mask type
   */
  mask: PropTypes.any,
  placeholderChar: PropTypes.string
};

export default DSInputMaskDeprecated;
//# sourceMappingURL=DSInputMaskDeprecated.js.map
